//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpCodeBlock from '../content/CodeBlock.vue';
import DpTextarea from '../textarea/Textarea.vue';

export default {
  name: 'DpCodeEditor',
  components: {
    DpTextarea,
    DpCodeBlock,
  },
  props: {
    lang: { type: String, default: 'json' },
    value: { required: true, type: null, default: '' },
    placeholder: { required: false, type: String, default: null },
  },
  data() {
    return {
      code: null,
      scrollPosition: { top: 0, left: 0 },
    };
  },
  computed: {
    height() {
      const PADDING = 15;
      const MIN_HEIGHT = 150;
      const LINE_HEIGHT = 23;

      if (!this.code) {
        return MIN_HEIGHT;
      }
      const lines = this.code.split(/\r*\n/).length;
      const calculatedHeight = (PADDING * 2) + (lines * LINE_HEIGHT);

      return Math.max(calculatedHeight, MIN_HEIGHT);
    },
    isPlaceholder() {
      return this.placeholder !== null && !this.code;
    },
  },
  watch: {
    value(newValue) {
      if (this.code === newValue) return;
      this.code = newValue;
    },
  },
  mounted() {
    this.code = this.value; // required when using with v-if
  },
  methods: {
    handleScroll(e) {
      const { scrollLeft } = e.target;
      this.scrollPosition.left = scrollLeft;
    },
    emitChanges() {
      this.$emit('input', this.code);
      this.$emit('change', this.code);
    },
  },
};
